import React, { useState } from 'react';
import { RuleGroupType, QueryBuilder, formatQuery } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.css';
import { ISqlFilterComponent } from 'src/pages/observers/components/SqlFilter/types';
import { CustomActionElement, CustomFieldSelector, CustomValueEditor, CustomValueSelector } from 'src/pages/observers/components/SqlFilter/components';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { QueryBuilderStylesContainer } from 'src/pages/observers/components/SqlFilter/styles';

const initialQuery: RuleGroupType = { combinator: 'and', rules: [], };

export default function SqlFilter (
	{
		label,
		fields,
		onConditionChange,
		required = false,
	}: ISqlFilterComponent
) {
	const [ query, setQuery, ] = useState(initialQuery);
	return (
		<FormItem>
			<FormLabel>
				{required && '* '}
				{label}
				{':'}
				<Tooltip
					title='Filtros dinâmicos para serem inseridos como condição na consulta SQL.'
				>
					<QuestionCircleOutlined
						style={{ color: 'rgba(0,0,0,0.45)', cursor: 'help', }}
					/>
				</Tooltip>
			</FormLabel>
			<QueryBuilderStylesContainer>
				<QueryBuilder
					fields={fields}
					query={query}
					onQueryChange={(q) => {
						setQuery(q);
						const sql = formatQuery(q, {
							format: 'sql',
							parseNumbers: true,
							fallbackExpression: `{{${label}}}`,
						});
						onConditionChange(sql);
					}}
					controlElements={{
						fieldSelector: CustomFieldSelector,
						valueEditor: CustomValueEditor,
						valueSelector: CustomValueSelector,
						actionElement: CustomActionElement,
					}}
					addRuleToNewGroups
				/>
			</QueryBuilderStylesContainer>
		</FormItem>
	);
}